import { APP_POOL_ALGORITHM_PATTERN, appPoolImageSchema } from "./app-pool.js";
import { z } from "zod";
//#region src/app-pool-autoscaler.ts
/**
* App-level autoscalers for pool knobs (2026-09-04-app-pools, I-4, I-5).
*
* An `autoscalers{}` entry in `app.json` names a fixture image whose entrypoint runs an autoscaler
* algorithm on the existing harness (`ScaleFn`/`ScaleContext` in `autoscale.ts`), and the signals
* the algorithm wants. A function-valued knob on a pool (`{ algorithm, max }`) names one of these
* entries. The operator's pool compiler polls the harness for the knob's value each reconcile
* cycle and clamps it to `max`. The runtime comes from the image, as it does for a pool (L-14).
*/
/** The queue signals a pool algorithm may ask for. Served by the operator's `signals` route
*  (`APP_POOL_SIGNALS_PATH`); none exists in today's collector menu (`AUTOSCALE_METRICS`). */
const APP_POOL_SIGNALS = [
	"queueDepth",
	"oldestMessageAgeSeconds",
	"inFlightAttempts"
];
/** One autoscaler entry: the image (a fixture in the bundle plus an entrypoint) and the non-empty,
*  unique list of signals it reads. */
const appPoolAutoscalerSchema = z.object({
	image: appPoolImageSchema,
	signals: z.array(z.enum(APP_POOL_SIGNALS)).min(1).refine((s) => new Set(s).size === s.length, { message: "signals must be unique" })
}).strict();
/** `app.json` `autoscalers`: keyed by algorithm name in the grammar a pool's `algorithm` uses. */
const appPoolAutoscalerNameSchema = z.string().min(1).max(63).regex(APP_POOL_ALGORITHM_PATTERN);
const appPoolAutoscalersSchema = z.record(appPoolAutoscalerNameSchema, appPoolAutoscalerSchema).refine((m) => Object.keys(m).length <= 8, { message: `an app declares at most 8 autoscalers` });
/** What the operator's `signals` route returns and the harness collector reads: one sample per
*  signal for one pool, stamped with the sample instant. */
const appPoolSignalsResponseSchema = z.object({
	pool: z.string().min(1),
	signals: z.partialRecord(z.enum(APP_POOL_SIGNALS), z.number().finite().min(0)),
	sampledAt: z.string().datetime()
}).strict();
//#endregion
export { APP_POOL_SIGNALS, appPoolAutoscalerNameSchema, appPoolAutoscalerSchema, appPoolAutoscalersSchema, appPoolSignalsResponseSchema };

//# sourceMappingURL=app-pool-autoscaler.js.map